import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common/common.service';
import { UiService } from '../services/uiloader/uiloader.service';
import { HttpService } from '../services/http/http.service';
import { config } from '../config';
import { Router } from '@angular/router';
import { DataService } from '../services/data/data.service';
import { LogService } from '../services/log/log.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ThemeService } from '../services/theme/theme.service';

let searchTimeout:any;

@Component({
  selector: 'app-prospects',
  templateUrl: './prospects.component.html',
  styleUrls: ['./prospects.component.sass']
})
export class ProspectsComponent implements OnInit {

  constructor(private commonService: CommonService,
    private ui: UiService,
    private httpService: HttpService,
    private router: Router,
    private logService: LogService,
    private dataService: DataService,
    public themeService: ThemeService) { }
    isShowCompancyClients:boolean=false;

  ngOnInit(): void {
    const routes:any = [{
      name: 'Clients',
      path: 'consultant-clients'
    }];
    this.commonService.gaEvent('prospects', 'prospects', 'Prospects Screen');

    this.commonService.setHeaderData(routes);
    this.fetchUsers();
  }

  displayedColumns: string[] = ['name','consultant', 'progress', 'status','settings'];
  dataSource = [];
  pagination = {
    count: 0,
    perPage: 25,
    pageIndex: 0,
    searchtext: '',
    totalCount: 0
  };

  statusUpdate(event:MatSlideToggleChange, clientId:any){
    const url = event.checked ? `/companyadmin/reactiveclient/${clientId}` : `/companyadmin/deactiveclient/${clientId}`;
    this.httpService.putCall(`${config.apiUrl}${url}`,{}).subscribe(data => {
    },
    err => {
     console.log(err);
    });
  }


  showCompanyClient(event: MatSlideToggleChange){
    this.isShowCompancyClients = event.checked;
     this.fetchUsers();
  }

  private getFormatedData(data:any) {
    const { rows = [], count = 0 } = data.consultantclients ? data.consultantclients : data;
    this.pagination.count = count;
    return rows.map((item:any) => ({
      id: item?.id,
      firstname: item.firstname,
      lastname: item.lastname,
      email: item.email,
      enabled: item.enabled,
      consultant: item.consultant,
      progress: item.survey_status.status
      //survey_completed: this.commonService.getFormattedDate(item.surveys_feedbacks[0].modified_at)
    }));
  }

  private fetchUsers() {
    this.ui.spin$.next(true);
    let clientsURL = this.isShowCompancyClients ? 'getclients' : 'consultantclients'
    const obj = {
      fromIndex: (this.pagination.pageIndex * this.pagination.perPage),
      limit: this.pagination.perPage,
      orderBy: "DESC",
      orderByOn: 'id',
      searchtext: this.pagination.searchtext
    };
    this.httpService.postCall(`${config.apiUrl}/${clientsURL}`, obj).subscribe((data:any) => {
      this.ui.spin$.next(false);
      this.dataSource = this.getFormatedData(data);
      // if (this.pagination.searchtext.length === 0) { //Commented by pavan on 26th Jan 22
        this.pagination.totalCount = data.count;
      // }     
    },
    err => {
      this.ui.spin$.next(false);
      this.dataSource = [];
      this.pagination.totalCount = 0;
      this.logService.logError(err);
    });
  }

  onSearchUser(x:any) {
    this.pagination.pageIndex = 0;
    this.pagination.searchtext = x.target.value;
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(()=>{
      this.fetchUsers();
    }, 1000);
  }

  getServerData(e:any) {
    this.pagination.pageIndex = e.pageIndex;
    this.pagination.perPage = e.pageSize;
    this.fetchUsers();
  }

  specificUser(item:any){
    this.commonService.gaEvent('specific_prospect', 'specific_prospect', 'On selecting specific user of Prospect');

    this.dataService.setProspectSelected(item);
    // this.router.navigate(['/prospectprofile']);
    this.router.navigate(['/userdetails', item.id ]);
  }

  navigateToSettings(item:any){
    this.router.navigate(['/userdetails', item.id ],{ queryParams: { tab: 'settings' }});
  }

  addUser() {
    this.router.navigate(['/adduser']);
  }

}
